'use client';

import Script from 'next/script';
export default function ChatBot() {
  return <Script id='chatbot' strategy='lazyOnload' dangerouslySetInnerHTML={{
    __html: `window.RAYCHAT_TOKEN = "d8493dba-7c56-4e9f-8204-b7f81fe0da1f";
      window.LOAD_TYPE = "SEO_FRIENDLY";
                (function () {
          d = document;
          s = d.createElement("script");
          s.src = "https://widget-react.raychat.io/install/widget.js";
          s.async = 1;
          d.getElementsByTagName("head")[0].appendChild(s);
        })();`
  }} data-sentry-element="Script" data-sentry-component="ChatBot" data-sentry-source-file="ChatBot.tsx" />;
}